import { style } from "@vanilla-extract/css";
import { primitiveTokens, semanticThemeTokens } from "../theme/ThemeTokens.css";

export const base = style({
  display: "flex",
  flexShrink: 0,
  alignSelf: "stretch",
  backgroundColor: semanticThemeTokens.divider.backgroundColor
});

export const orientationVariants = {
  horizontal: style({
    height: primitiveTokens.borderWidth.default,
    width: "100%"
  }),

  vertical: style({
    width: primitiveTokens.borderWidth.default,
    height: "100%"
  })
};

export const dividerWithText = style({
  display: "flex",
  alignItems: "center",
  textAlign: "center",
  width: "100%",
  whiteSpace: "nowrap",
  fontSize: primitiveTokens.type.xs,
  color: semanticThemeTokens.divider.color,
  paddingLeft: primitiveTokens.sizing["6x"],
  paddingRight: primitiveTokens.sizing["6x"],
  "::before": {
    content: '""',
    flex: 1,
    height: "1px",
    backgroundColor: semanticThemeTokens.divider.backgroundColor,
    marginRight: primitiveTokens.sizing["6x"]
  },

  "::after": {
    content: '""',
    flex: 1,
    height: "1px",
    backgroundColor: semanticThemeTokens.divider.backgroundColor,
    marginLeft: primitiveTokens.sizing["6x"]
  }
});
